<div class="flex justify-content-center p-3 text-sm">
    <a class="no-underline text-primary cursor-pointer" (click)="openCguDialog($event)">Conditions d'utilisation</a>
    <div class="mx-3">•</div>
    <a class="no-underline text-primary cursor-pointer" (click)="openPrivacyDialog($event)">Politique de confidentialité</a>
</div>
